import axios from '../axios';

export type TranslationEntry = {
  id: string
  key: string
  language: string
  value: string
}

export type UpsertTranslationReq = {
  key: string
  language: string
  value: string
}

export namespace TranslationsController {
  export const getTranslations = async () =>
    (await axios.get<TranslationEntry[]>('/internal/translations')).data

  export const upsertTranslation = async (req: UpsertTranslationReq) =>
    (await axios.put('/internal/translations', req))

  export const deleteTranslation = async (id: string) =>
    (await axios.delete(`/internal/translations/${id}`))
}
